import { ResultOf } from "gql.tada";
import { GetArticlePageBySlug } from "@queries/GetArticlePageBySlug";
import * as Dialog from "@radix-ui/react-dialog";
import { AnimatePresence, motion } from "motion/react";
import { IconX } from "@hawkins/assets";
import { MediaItem } from "./MediaItem";
import { MarkdownLite } from "./MarkdownLite";

export const VideoModal = ({
  articlePage,
  open,
}: {
  articlePage: NonNullable<
    ResultOf<typeof GetArticlePageBySlug>["articlePageCollection"]
  >["items"][number];
  open: boolean;
}) => {
  return (
    <AnimatePresence mode="wait">
      {open && articlePage && (
        <Dialog.Portal forceMount key={articlePage.slug}>
          <Dialog.Overlay asChild>
            <motion.div
              className="fixed inset-0 z-[200]"
              initial={{ backgroundColor: "rgb(var(--brand-black) / 0)" }}
              animate={{ backgroundColor: "rgb(var(--brand-black) / 0.94)" }}
              exit={{ backgroundColor: "rgb(var(--brand-black) / 0)" }}
            />
          </Dialog.Overlay>
          <Dialog.Content className="fixed inset-0 z-[200] flex items-center justify-center p-4 dsk:p-10 focus:outline-none">
            <motion.div
              className="w-full max-w-[1400px] flex flex-col gap-4"
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.92 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            >
              <div className="flex items-center justify-between">
                <Dialog.DialogTitle asChild>
                  <p className="text-brand-cream text-body-small uppercase opacity-70">
                    <MarkdownLite>{articlePage.title}</MarkdownLite>
                  </p>
                </Dialog.DialogTitle>
                <Dialog.Close asChild>
                  <button className="size-9 min-w-9 min-h-9 rounded-lg bg-brand-cream/10 flex items-center justify-center focus:outline-none hover:scale-110 focus-visible:scale-110 active:scale-90 transition-transform">
                    <IconX className="text-brand-cream" size="small" />
                  </button>
                </Dialog.Close>
              </div>
              {articlePage.heroImage && (
                <div className="rounded-2xl overflow-hidden w-full h-[80vh] flex items-center justify-center bg-brand-black/50">
                  <MediaItem
                    item={articlePage.heroImage}
                    className="w-full h-full object-contain"
                    controls
                    muted={false}
                    autoPlay={false}
                    width={1400}
                  />
                </div>
              )}
            </motion.div>
          </Dialog.Content>
        </Dialog.Portal>
      )}
    </AnimatePresence>
  );
};
